import { createFeatureSelector, createSelector } from '@ngrx/store';
import { EnumsState } from './enumeration.model';

const selectState = createFeatureSelector<EnumsState>('enumsState');

export const selectEnumsState = createSelector(
  selectState,
  (state: EnumsState) => state
);

export const selectEnumFields = createSelector(
  selectState,
  (state: EnumsState) => state?.enumFields
);
